import { Component } from 'nuxt-property-decorator'
import Vue from 'vue'
import LoaderModule from '~/store/LoaderModule'
import { getModule } from 'vuex-module-decorators'
import Pledge from '~/classes/Pledge'
import Loader from '~/classes/Loader'

@Component
export default class LoaderMixin extends Vue {
  loaderStore: LoaderModule = getModule(LoaderModule, this.$store)

  get isLoadingAny () {
    return this.loaderStore.isLoadingAny
  }

  public async load<T> (id: string, pledge: Pledge<T>): Promise<T | undefined> {
    const loader = new Loader(id, pledge)
    this.loaderStore.addLoader(loader)

    const result = await loader.go()
    this.loaderStore.removeLoader(loader)

    return result
  }

  public isLoading (id: string): boolean {
    return this.loaderStore.isLoading(id)
  }
}
